// True while scripts/prerender.js is capturing static HTML. Animation "armed" states are skipped then,
// so the saved markup always shows final content and matches what React renders on the first pass.
export const isPrerender = (): boolean => typeof window !== 'undefined' && (window as any).__PRERENDER__ === true;
